/**
 * Rastreamento de pedido (formulário público na página "Rastrear pedido").
 *
 * Chama o endpoint do bling-mcp (`POST /api/track-order`), que consulta o
 * Shopify Admin API do lado do servidor — o token de admin nunca fica
 * exposto no tema. Resposta genérica "não encontrado" tanto para número
 * errado quanto para e-mail errado, para não vazar quais pedidos existem.
 */

(function () {
  'use strict';

  var form = document.getElementById('OrderTrackingForm');
  if (!form) return;

  var endpoint = form.dataset.endpoint;
  var resultEl = document.getElementById('OrderTrackingResult');
  var submitButton = form.querySelector('button[type="submit"]');

  function setLoading(isLoading) {
    if (submitButton) submitButton.disabled = isLoading;
    form.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function showMessage(message, isError) {
    resultEl.textContent = message;
    resultEl.hidden = false;
    resultEl.setAttribute('role', isError ? 'alert' : 'status');
    resultEl.classList.toggle('order-tracking__result--error', !!isError);
  }

  function formatDate(iso) {
    try {
      return new Intl.DateTimeFormat('pt-BR').format(new Date(iso));
    } catch (e) {
      return iso;
    }
  }

  function renderOrder(order) {
    resultEl.innerHTML = '';
    resultEl.hidden = false;
    resultEl.removeAttribute('role');
    resultEl.classList.remove('order-tracking__result--error');

    var heading = document.createElement('p');
    heading.className = 'order-tracking__status';
    heading.textContent = 'Pedido ' + order.orderName + ' — ' + statusLabel(order.fulfillmentStatus) + ' (feito em ' + formatDate(order.createdAt) + ')';
    resultEl.appendChild(heading);

    var trackingEntries = (order.trackingInfo || []).filter(function (t) {
      return t.number || t.url;
    });

    if (trackingEntries.length === 0) {
      var pending = document.createElement('p');
      pending.textContent = 'Ainda não há código de rastreio disponível para este pedido.';
      resultEl.appendChild(pending);
      return;
    }

    var list = document.createElement('ul');
    list.className = 'order-tracking__tracking-list';
    trackingEntries.forEach(function (t) {
      var item = document.createElement('li');
      var label = (t.company ? t.company + ': ' : '') + (t.number || '');
      if (t.url) {
        var link = document.createElement('a');
        link.href = t.url;
        link.target = '_blank';
        link.rel = 'noopener';
        link.className = 'link';
        link.textContent = label || t.url;
        item.appendChild(link);
      } else {
        item.textContent = label;
      }
      list.appendChild(item);
    });
    resultEl.appendChild(list);
  }

  function statusLabel(status) {
    var labels = {
      FULFILLED: 'entregue aos Correios/transportadora',
      IN_PROGRESS: 'em separação',
      PARTIALLY_FULFILLED: 'parcialmente enviado',
      UNFULFILLED: 'aguardando envio',
      ON_HOLD: 'em espera',
      SCHEDULED: 'agendado',
    };
    return labels[status] || status;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var orderNumber = form.elements.orderNumber.value.trim();
    var email = form.elements.email.value.trim();
    if (!orderNumber || !email) return;

    resultEl.hidden = true;
    setLoading(true);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderNumber: orderNumber, email: email }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('request failed');
        return res.json();
      })
      .then(function (data) {
        if (!data.found) {
          showMessage('Não encontramos nenhum pedido com esse número e e-mail. Confira os dados e tente novamente.', true);
          return;
        }
        renderOrder(data.order);
      })
      .catch(function () {
        showMessage('Não foi possível consultar seu pedido agora. Tente novamente em instantes.', true);
      })
      .finally(function () {
        setLoading(false);
      });
  });
})();
